import { render, staticRenderFns } from "./PrisonerLocations.vue?vue&type=template&id=426675a4&"
import script from "./PrisonerLocations.vue?vue&type=script&lang=js&"
export * from "./PrisonerLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports